import React from 'react';

interface CarIconProps {
  fill?: string;
  height?: string | number;
  width?: string | number;
}

const CarIcon = ({ fill = '#BEBEBE', height = '19', width = '19' }: CarIconProps) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.61532 18.5V20.5H3.5V12.0769L5.80577 5.50003H18.1942L20.5 12.0769V20.5H18.3846V18.5H5.61532ZM5.60765 10.577H18.3923L17.1308 7.00001H6.8692L5.60765 10.577ZM7.46378 15.8462C7.82764 15.8462 8.13618 15.7188 8.38938 15.4641C8.64259 15.2094 8.7692 14.9001 8.7692 14.5362C8.7692 14.1723 8.64184 13.8638 8.38713 13.6106C8.13241 13.3574 7.82312 13.2308 7.45925 13.2308C7.09538 13.2308 6.78684 13.3581 6.53363 13.6129C6.28043 13.8676 6.15383 14.1769 6.15383 14.5407C6.15383 14.9046 6.28118 15.2131 6.5359 15.4664C6.79062 15.7196 7.09991 15.8462 7.46378 15.8462ZM16.5407 15.8462C16.9046 15.8462 17.2131 15.7188 17.4663 15.4641C17.7195 15.2094 17.8461 14.9001 17.8461 14.5362C17.8461 14.1723 17.7188 13.8638 17.4641 13.6106C17.2093 13.3574 16.9 13.2308 16.5362 13.2308C16.1723 13.2308 15.8638 13.3581 15.6106 13.6129C15.3574 13.8676 15.2308 14.1769 15.2308 14.5407C15.2308 14.9046 15.3581 15.2131 15.6128 15.4664C15.8675 15.7196 16.1768 15.8462 16.5407 15.8462ZM4.99997 17H19V12.0769H4.99997V17Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default CarIcon;
